export const LOAD_ANIMATION_CONFIG = {
  renderer: "svg",
  renderderSettings: {
    preserveAspectRatio: "xMinYMin slice",
  },
};

export const EVENT = {
  ENTER_FRAME: "enterFrame",
  LOOP_COMPLETE: "loopComplete",
  COMPLETE: "complete",
  DATA_READY: "data_ready",
};

export const RANGE_INPUT = "range";
